import { gql } from 'graphql-request'

import graphQLRequest from '@/CandidateExperience/config/graphQLRequest'

const FETCH_POSITION_MATCHING_REQUIREMENTS = gql`
  query positionMatchingRequirements($positionId: ID!, $candidateProfileId: ID!) {
    matchingRequirements(positionId: $positionId, candidateProfileId: $candidateProfileId) {
      role
      roleExperience
      allMustHaveSkills
      employmentType
      remotePolicyAndLocation
      visaRequirements
    }
  }
`

export const getPositionMatchingRequirements = ({ positionId, candidateProfileId }) => {
  return graphQLRequest(FETCH_POSITION_MATCHING_REQUIREMENTS, { positionId, candidateProfileId })
}
